import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { InquiryRow } from '@models/inquiry';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';

import InquiryBadge from '../InquiryBadge';

interface Props {
    inquiry: InquiryRow;
}

function InquiryItem({ inquiry }:Props) {
    const {
        status, createdAt, title, inquiryId, content,
    } = inquiry;
    return (
        <Link activityParams={{ inquiryId }}
            activityName='InquiryLogActivity'
            css={cardCss} >
            <Row spacing={2}>
                <InquiryBadge status={status} />
                <Text size='label-lg' fontWeight='medium' color={colors.textThird}>
                    {dayjs(createdAt).format('YYYY.MM.DD')}
                </Text>
            </Row>
            <Text size='title' fontWeight='medium' color={colors.textPrimary} css={clampCss}>
                {title}
            </Text>
            <Text color={colors.textSecondary} css={clampCss}>
                {content}
            </Text>
        </Link>
    );
}

const clampCss = css`
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-all;
`;

export const cardCss = css`
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    padding: var(--spacing-4);
    row-gap: var(--spacing-4);
    width: 100%;
    ${pressActionEffect}
`;

export default InquiryItem;
